/* Desktop behaviour for the homepage "Shop Womens / Shop Mens" carousels (sections/collection-showcase.liquid).
   That section centres a "featured" card and pads the row by half the screen on each side, which works on a
   phone but on desktop leaves a large empty gap and cards running off the edge.
   On desktop (750px+) this script, which loads before the section starts up on window load:
   - drops the "featured" state so every card is the same size and nothing re-centres or resizes on click
   - keeps the row at the normal page margin (styles injected below)
   - adds square prev/next arrows to the section heading that scroll smoothly a screen at a time
   - makes a click anywhere on a card open its collection
   Mobile is left exactly as the section builds it. Loaded on the homepage by snippets/stryd-offers-engine.liquid. */
(function () {
  'use strict';
  if (!window.matchMedia('(min-width: 750px)').matches) return;

  /* desktop styles for the arrows and the margin-aligned row (kept here so the whole fix lives in one file) */
  var style = document.createElement('style');
  style.textContent = "section.collection-showcase .cs__header { position: relative; } section.collection-showcase .cs__track { padding-left: 40px !important; padding-right: 40px !important; scroll-snap-type: x proximity !important; scroll-padding-inline: 40px; scroll-behavior: smooth; } section.collection-showcase .cs__card { scroll-snap-align: start !important; } section.collection-showcase .sk-cs-nav { position: absolute; right: 40px; top: 50%; transform: translateY(-50%); display: flex; gap: 8px; } section.collection-showcase .sk-cs-arrow { width: 44px; height: 44px; display: grid; place-items: center; cursor: pointer; padding: 0; background: #FFFFFF; color: #000000; border: 1px solid #000000; border-radius: 0; transition: background-color 160ms cubic-bezier(.4, 0, .2, 1), color 160ms cubic-bezier(.4, 0, .2, 1); } section.collection-showcase .sk-cs-arrow:hover:not([disabled]) { background: #000000; color: #FFFFFF; } section.collection-showcase .sk-cs-arrow[disabled] { opacity: .3; cursor: default; } section.collection-showcase .sk-cs-arrow svg { width: 16px; height: 16px; }";
  document.head.appendChild(style);

  var ARROW_PREV = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M10 3 5 8l5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="square"/></svg>';
  var ARROW_NEXT = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m6 3 5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="square"/></svg>';

  function setup(section) {
    if (section.getAttribute('data-sk-showcase')) return;
    var track = section.querySelector('.cs__track');
    if (!track) return;
    section.setAttribute('data-sk-showcase', '1');

    /* same size cards, no auto-centring */
    track.querySelectorAll('.cs__card--featured').forEach(function (c) { c.classList.remove('cs__card--featured'); });

    /* card click opens the collection (capture phase, so the section's resize-and-centre handler never runs) */
    track.addEventListener('click', function (e) {
      if (e.target.closest('.cs__btn')) return;
      var card = e.target.closest('.cs__card');
      if (!card) return;
      e.stopPropagation();
      var url = card.getAttribute('data-url');
      if (url && url !== '#') window.location.href = url;
    }, true);

    /* arrows */
    var header = section.querySelector('.cs__header');
    var nav = document.createElement('div');
    nav.className = 'sk-cs-nav';
    nav.innerHTML =
      '<button type="button" class="sk-cs-arrow" data-dir="-1" aria-label="Previous">' + ARROW_PREV + '</button>' +
      '<button type="button" class="sk-cs-arrow" data-dir="1" aria-label="Next">' + ARROW_NEXT + '</button>';
    (header || section).appendChild(nav);
    var arrows = nav.querySelectorAll('.sk-cs-arrow');

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      arrows[0].disabled = track.scrollLeft <= 2;
      arrows[1].disabled = track.scrollLeft >= max;
      nav.style.visibility = max <= 0 ? 'hidden' : '';
    }
    arrows.forEach(function (b) {
      b.addEventListener('click', function () {
        var card = track.querySelector('.cs__card');
        var step = track.clientWidth - (card ? card.offsetWidth / 2 : 0);
        track.scrollBy({ left: Number(b.getAttribute('data-dir')) * step, behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    window.addEventListener('load', function () { track.scrollLeft = 0; sync(); });
    sync();
  }

  function run() { document.querySelectorAll('section.collection-showcase').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
